import React from 'react';
import './LiveGuestPresence.css';

export default function LiveGuestPresence({ guests = [] }) {
  return (
    <div className="live-guest-presence" role="group" aria-label="Connected guests" tabIndex={guests.length ? 0 : undefined}>
      <span className="live-guest-presence__count">Connected: {guests.length}</span>
      <ul className="live-guest-presence__list">
        {guests.map(guest => {
          const speaking = guest.inVoice && guest.speaking;
          const role = guest.role === 'streamer' ? ', streamer' : '';
          const activity = speaking ? ', speaking' : guest.inVoice && guest.activityKnown === false ? ', activity unavailable' : '';
          return (
            <li key={guest.id} data-speaking={Boolean(speaking)} data-in-voice={Boolean(guest.inVoice)}
              className={`live-guest-presence__guest${guest.inVoice ? ' is-in-voice' : ''}${speaking ? ' is-speaking' : ''}`}
              aria-label={`${guest.name}${role}, ${guest.inVoice ? 'in voice' : 'not in voice'}${activity}`}
              title={`${guest.name}${role}${guest.inVoice ? ' · in voice' : ''}${activity}`}>
              <span className="live-guest-presence__name">{guest.name}</span>
              {guest.role === 'streamer' && <span className="live-guest-presence__role">streamer</span>}
              {guest.inVoice && <span className="live-guest-presence__voice">voice</span>}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
